<lgb-header-gradient [background]="true"></lgb-header-gradient>
<div class="screen-container">
	<lgb-back name="sign"></lgb-back>
	<h1 class="text-primary mt-4 mb-2">Conditions générales d’utilisation</h1>
	<h2 class="text-primary text-lg">1. Objet</h2>
	<div class="mb-4 text-xs text-justify">
		Les présentes Conditions Générales d’Utilisation (CGU) ont pour objet de définir les modalités d’accès et d’utilisation de l’application Legend-Binder.<br/>
		Toute utilisation du service implique l’acceptation pleine et entière des présentes CGU.
	</div>
	<h2 class="text-primary text-lg">2. Accès au service</h2>
	<div class="mb-4 text-xs text-justify">
		L’accès au service est réservé aux utilisateurs disposant d’un compte valide.<br/>
		L’utilisateur est responsable :
		<ul class="list-disc pl-5">
			<li>de la création de son compte</li>
			<li>de la sécurité de ses identifiants</li>
			<li>de toute activité réalisée via son compte</li>
		</ul>
		L’utilisateur s’engage à ne pas partager son compte avec des tiers.
	</div>
	<h2 class="text-primary text-lg">3. Conditions d’éligibilité</h2>
	<div class="mb-4 text-xs text-justify">
		L’utilisateur déclare :
		<ul class="list-disc pl-5">
			<li>être âgé d’au moins 18 ans, ou disposer de l’autorisation d’un représentant légal</li>
			<li>avoir la capacité juridique de contracter</li>
		</ul>
	</div>
	<h2 class="text-primary text-lg">4. Fonctionnalités du service</h2>
	<div class="mb-4 text-xs text-justify">
		L’application Legend-Binder permet notamment :
		<ul class="list-disc pl-5">
			<li>la gestion de collections de cartes</li>
			<li>la visualisation de classeurs numériques</li>
			<li>l’accès à des données informatives relatives aux cartes</li>
		</ul>
		Les fonctionnalités sont susceptibles d’évoluer à tout moment.
	</div>
	<h2 class="text-primary text-lg">5. Données utilisateur</h2>
	<div class="mb-4 text-xs text-justify">
		L’utilisateur reste propriétaire des contenus qu’il renseigne dans l’application.
		Toutefois, il concède à l’éditeur une licence non exclusive, gratuite et mondiale permettant :
		<ul class="list-disc pl-5">
			<li>l’hébergement</li>
			<li>la reproduction</li>
			<li>l’affichage</li>
			<li>le traitement</li>
		</ul>
		des données, strictement aux fins de fourniture du service.
	</div>
	<h2 class="text-primary text-lg">6. Suppression du compte</h2>
	<div class="mb-4 text-xs text-justify">
		L’utilisateur peut demander la suppression de son compte à tout moment.<br/>
		La suppression entraîne :
		<ul class="list-disc pl-5">
			<li>la suppression définitive des données associées</li>
			<li>l’impossibilité de récupération ultérieure</li>
		</ul>
	</div>
	<h2 class="text-primary text-lg">7. Disponibilité du service</h2>
	<div class="mb-4 text-xs text-justify">
		Le service est fourni "en l’état".<br/>
		L’éditeur ne garantit pas :
		<ul class="list-disc pl-5">
			<li>une disponibilité continue</li>
			<li>l’absence d’erreurs ou de bugs</li>
		</ul>
		L’accès peut être suspendu temporairement pour maintenance ou évolution.
	</div>
	<h2 class="text-primary text-lg">8. Évolution du service</h2>
	<div class="mb-4 text-xs text-justify">
		L’éditeur se réserve le droit de :
		<ul class="list-disc pl-5">
			<li>modifier les fonctionnalités</li>
			<li>ajouter ou supprimer des services</li>
			<li>faire évoluer l’interface</li>
		</ul>
		sans préavis et sans indemnité.
	</div>
	<h2 class="text-primary text-lg">9. Règles d’utilisation</h2>
	<div class="mb-4 text-xs text-justify">
		L’utilisateur s’engage à utiliser le service :
		<ul class="list-disc pl-5">
			<li>conformément aux lois et réglementations en vigueur</li>
			<li>de manière loyale et non abusive</li>
		</ul>

		Il est interdit d’utiliser le service à des fins :
		<ul class="list-disc pl-5">
			<li>frauduleuses</li>
			<li>commerciales non autorisées</li>
			<li>nuisibles au fonctionnement de la plateforme</li>
		</ul>
	</div>
	<h2 class="text-primary text-lg">10. Données et informations fournies</h2>
	<div class="mb-4 text-xs text-justify">
		Les données accessibles via l’application sont :
		<ul class="list-disc pl-5">
			<li>fournies à titre informatif</li>
			<li>non contractuelles</li>
			<li>susceptibles d’évolution</li>
		</ul>
		L’utilisateur reconnaît que ces données peuvent être :
		<ul class="list-disc pl-5">
			<li>inexactes</li>
			<li>incomplètes</li>
			<li>obsolètes</li>
		</ul>
		L’éditeur ne garantit en aucun cas leur fiabilité.
	</div>
	<h2 class="text-primary text-lg">11. Sources de données tierces</h2>
	<div class="mb-4 text-xs text-justify">
		Certaines informations peuvent provenir de sources externes.<br/>
		L’éditeur :
		<ul class="list-disc pl-5">
			<li>ne garantit pas leur exactitude</li>
			<li>ne peut être tenu responsable de leur contenu</li>
			<li>se réserve le droit de modifier ou supprimer ces données à tout moment</li>
		</ul>
	</div>
	<h2 class="text-primary text-lg">12. Propriété intellectuelle</h2>
	<div class="mb-4 text-xs text-justify">
		L’application Legend-Binder ainsi que l’ensemble de ses composants sont protégés par le droit de la propriété intellectuelle.<br/>
		Toute reproduction ou exploitation non autorisée est interdite.
	</div>
	<h2 class="text-primary text-lg">13. Interdictions techniques</h2>
	<div class="mb-4 text-xs text-justify">
		Il est strictement interdit de :
		<ul class="list-disc pl-5">
			<li>effectuer du scraping ou de l’extraction automatisée de données</li>
			<li>utiliser des bots ou scripts automatisés</li>
			<li>tenter d’accéder aux systèmes ou bases de données</li>
			<li>contourner les mesures de sécurité</li>
			<li>procéder à toute rétro-ingénierie, décompilation ou désassemblage</li>
			<li>exploiter les données à des fins concurrentielles</li>
		</ul>
		Toute tentative d’atteinte à la sécurité ou au fonctionnement du service est interdite.
	</div>
	<h2 class="text-primary text-lg">14. Sécurité</h2>
	<div class="mb-4 text-xs text-justify">
		L’utilisateur s’engage à :
		<ul class="list-disc pl-5">
			<li>ne pas perturber le fonctionnement du service</li>
			<li>signaler toute faille de sécurité constatée</li>
		</ul>
		Toute tentative de test de sécurité non autorisée est interdite.
	</div>
	<h2 class="text-primary text-lg">15. Responsabilité</h2>
	<div class="mb-4 text-xs text-justify">
		Le service est fourni sans garantie.<br/>
		L’éditeur ne pourra être tenu responsable :
		<ul class="list-disc pl-5">
			<li>des dommages indirects</li>
			<li>des pertes financières</li>
			<li>des décisions prises sur la base des informations fournies</li>
		</ul>
	</div>
	<h2 class="text-primary text-lg">16. Suspension ou suppression de compte</h2>
	<div class="mb-4 text-xs text-justify">
		L’éditeur se réserve le droit de suspendre ou supprimer tout compte en cas de :
		<ul class="list-disc pl-5">
			<li>violation des présentes CGU</li>
			<li>usage abusif ou frauduleux</li>
			<li>atteinte au bon fonctionnement du service</li>
		</ul>
	</div>
	<h2 class="text-primary text-lg">17. Fermeture du service</h2>
	<div class="mb-4 text-xs text-justify">
		L’éditeur se réserve le droit de mettre fin à tout ou partie du service à tout moment.<br/>
		Aucune indemnité ne pourra être réclamée à ce titre.
	</div>
	<h2 class="text-primary text-lg">18. Modification des CGU</h2>
	<div class="mb-4 text-xs text-justify">
		L’éditeur se réserve le droit de modifier les présentes CGU à tout moment.<br/>
		Les nouvelles versions entrent en vigueur dès leur mise en ligne.<br/>
		L’utilisateur est invité à consulter régulièrement les CGU.<br/>
		L’éditeur n’est pas tenu de notifier individuellement les utilisateurs.
	</div>
	<h2 class="text-primary text-lg">19. Droit applicable</h2>
	<div class="mb-4 text-xs text-justify">
		Les présentes CGU sont soumises au droit français.
	</div>
	<h2 class="text-primary text-lg">20. Contact</h2>
	<div class="mb-4 text-xs text-justify">
		Pour toute question ou réclamation :
		anthony@legend-binder.com
	</div>
</div>